// src/pages/info-destacada/EliminarInfo.js
import React from 'react'
import Modal from 'react-bootstrap/Modal'
import Alert from 'react-bootstrap/Alert'
import Button from 'react-bootstrap/Button'
import { getIconClass } from 'components/IconSelector'

function EliminarInfo(props) {
	const { item, mostrar, cancelar, eliminar } = props

	const handleClose = () => {
		cancelar()
	}

	const handleEliminar = () => {
		if (item?.id) {
			eliminar(item.id)
		}
	}

	if (!item) {
		return null
	}

	// render
	return (
		<Modal show={mostrar} onHide={handleClose}>
			<Modal.Header closeButton>
				<Modal.Title>Eliminar Información Destacada</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<Alert variant="danger">
					<i className="fa fa-exclamation-triangle me-2"></i>
					Está a punto de eliminar la siguiente información destacada. Esta acción no se puede deshacer.
				</Alert>

				<div className="p-3 bg-light rounded mb-3">
					<div className="d-flex align-items-center gap-3">
						<i className={`${getIconClass(item.icono)} fa-2x text-secondary`}></i>
						<div>
							<h6 className="text-muted mb-1">Título:</h6>
							<p className="mb-0" dangerouslySetInnerHTML={{ __html: item.titulo }}></p>
						</div>
					</div>
				</div>

				<p className="mb-0">¿Está seguro que desea continuar?</p>
			</Modal.Body>
			<Modal.Footer>
				<Button variant="outline-secondary" onClick={handleClose}>
					<i className="fa fa-times me-2"></i>
					Cancelar
				</Button>
				<Button variant="danger" onClick={handleEliminar}>
					<i className="fa fa-trash me-2"></i>
					Eliminar
				</Button>
			</Modal.Footer>
		</Modal>
	)
}

export default EliminarInfo
